export default Backbone.View.extend({
  // An abstract base class which is resposible for setting up
  // Backbone.stickit's two way binding.  Since the HTML is rendered
  // server-side, we don't have to do any client-side rendering.

  initialize() {
    this.render();
  },

  render() {
    this.stickit();
    return this;
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/static_stickit_view.js